import { Suspense } from "react";
import { routes } from ".";
import { Route, Routes } from "react-router-dom";

const RouterPage = () => {
   const getRoutes = () => {
      return routes.map((route, index) => {
         return route.element && (
            <Route
               key={index}
               exact={true}
               path={route.path}
               element={route.element}
            />
         );
      });
   }

   return (
      <Suspense>
         <Routes>
            {getRoutes()}
         </Routes>
      </Suspense>
   )
}

export default RouterPage;